import { useSelector } from "react-redux"
import { getCurrencySymbol } from "reducers/companyInfo"
import Helpers from "utils/Helpers"
import React, { FC } from "react"

type CurrencyStringProps = {
  amount: number
}

const CurrencyString: FC<CurrencyStringProps> = ({ amount }: CurrencyStringProps) => {
  const currencySymbol = useSelector(getCurrencySymbol)
  return <>{Helpers.convertToCurrencyString(amount, currencySymbol, 2)}</>
}

const UsdCurrencyString: FC<CurrencyStringProps> = ({ amount }: CurrencyStringProps) => {
  const usdCurrencySymbol = "$"
  return <>{Helpers.convertToCurrencyString(amount, usdCurrencySymbol, 2)}</>
}

const CurrencyStringNoDecimals: FC<CurrencyStringProps> = ({ amount }: CurrencyStringProps) => {
  const currencySymbol = useSelector(getCurrencySymbol)
  return <>{Helpers.convertToCurrencyString(amount, currencySymbol, 0)}</>
}

export { CurrencyString, UsdCurrencyString, CurrencyStringNoDecimals }
